/**
 * Created by Ning Jiang on 12/12/2018.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {JusticeOutroWPView} from "./JusticeOutroWPView";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";

export class JusticeOutroWPController extends WinPresentationController {

    private _view:JusticeOutroWPView;
    private _timeline:TimelineLite;
    private _soundPlayed:boolean = false;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "JusticeOutro", skippable : true});

        this._view = new JusticeOutroWPView();
    }

    protected hasWin():boolean {
        return this._gameData!.mode === GameMode.RESPIN && this._gameData!.nextMode === GameMode.NORMAL;
    }

    protected startWinPresentation():void {
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        const showTimeline:TimelineLite = this._view.show(this._gameData!.totalWin, (<TombstoneParsedGameData>this._gameData!).numberOfBonusSpinsPlayed, true);
        const endingTimeline:TimelineLite = this._view.playEnding(this._gameData!.totalWin, (<TombstoneParsedGameData>this._gameData!).numberOfBonusSpinsPlayed, false);
        this._timeline = new TimelineLite();
        this._timeline.add(() =>
            TombstoneGameModuleConfig.TBBWController.hideCountUp());
        this._timeline.add(() => showTimeline.play());
        this._timeline.add(() => this.playMainSound(), 0);
        this._timeline.add(() => endingTimeline.play(), `+=3.5`);
        this._timeline.add(() => this.finish(), `+=${endingTimeline.totalDuration()}`);
        this._timeline.play();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline) {
            if(this._timeline.isActive()) {
                this._timeline.pause();
                this._timeline.kill();
            }
        }

        if(isAborted) {
            SlotGame.keypad.setZeroBetSpinCounter(-1);
            this._view.playEnding(this._gameData!.totalWin, (<TombstoneParsedGameData>this._gameData!).numberOfBonusSpinsPlayed, isAborted);
            if(!this._soundPlayed) {
                this.playMainSound();
            }
        }
    }

    private playMainSound():void {
        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 5000);

        // #277
        if (!(SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this._gameData!.totalWin <= this._gameData!.playedBetValue))) {
            SlotGame.sound.playEffect(this._gameData!.totalWin > 0 ? TombstoneSoundConfig.instance.JUSTICE_OUTRO : TombstoneSoundConfig.instance.JUSTICE_NOWIN_OUTRO);
        }

        this._soundPlayed = true;
    }

    public reset():void {
        this._soundPlayed = false;
    }
}